﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class KDMZAction extends TKCustomElementFactory {
    private controls: HTMLInputElement[] = [];

    /**
     * Bereits im HTML vorhandenes Hidden-Feld für die Submit-Aktion.
     */
    private submitActionField?: HTMLInputElement;

    /**
     * Submit-Buttons, die die Submit-Aktion setzen.
     */
    private submitButtons: HTMLButtonElement[] = [];

    constructor() {
        super();
    }

    connectedCallback(): void {
        // Submit-Aktion initialisieren
        this.initializeSubmitAction();
    }

    disconnectedCallback(): void {
        this.submitButtons.forEach((button) => {
            button.removeEventListener('click', this.handleSubmitButtonClick);
        });

        this.controls = [];
        this.submitButtons = [];
        this.submitActionField = undefined;
    }

    private handleChange = (): void => {
        this.update();
    };

    /**
     * Sucht das bereits im HTML vorhandene Hidden-Feld
     * und die Submit-Buttons "save" und "next".
     */
    private initializeSubmitAction(): void {
        const form = this.closest('form');

        if (!form) {
            return;
        }

        this.submitActionField = form.querySelector<HTMLInputElement>(
            'input[type="hidden"][name="submitAction"], input[type="text"][name="submitAction"]',
        );

        if (this.submitActionField) {
            // Initial leer
            this.submitActionField.value = '';
        }

        this.submitButtons = Array.from(
            form.querySelectorAll<HTMLButtonElement>(
                'button[type="submit"][name="save"], ' + 'button[type="submit"][name="next"]',
            ),
        );

        this.submitButtons.forEach((button) => {
            button.addEventListener('click', this.handleSubmitButtonClick);
        });

        form.addEventListener('submit', this.handleFormSubmit);
    }

    /**
     * Setzt submitAction auf den Namen des geklickten Submit-Buttons.
     */
    private handleSubmitButtonClick = (event: MouseEvent): void => {
        if (!this.submitActionField) {
            return;
        }

        const button = event.currentTarget;

        if (button instanceof HTMLButtonElement) {
            this.submitActionField.value = button.name;
        }
    };

    /**
     * Verhindert das Absenden nur dann,
     * wenn ein submitAction-Feld vorhanden, aber leer ist.
     */
    private handleFormSubmit = (event: SubmitEvent): void => {
        // Kein submitAction-Feld vorhanden → Absenden erlauben
        if (!this.submitActionField) {
            return;
        }

        // submitAction vorhanden, aber leer → Absenden verhindern
        if (!this.submitActionField.value.trim()) {
            event.preventDefault();
        }
    };
}
